import { CONSOLE_PATHS, PRODUCT_NAME } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink } from "@sagot/ui";
import { useNavigate, useSearchParams } from "react-router";
import { readPendingAuth } from "../session/pending-auth";
import { AuthLayout } from "./components/auth-layout";
import { FormAlert } from "./components/form-alert";
import { RegisterVerifyPane } from "./register-verify-pane";
import { useCompleteSignIn } from "./use-sign-in";

/**
 * `/verify-email?email=`: the code pane on its own, for the links and redirects that already exist (an unverified account signing
 * in, a mail from before the wizard). Same pane as the wizard's last step; a verified code signs in and opens onboarding.
 */
export function VerifyEmailPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const pending = readPendingAuth();
  const email = params.get("email") ?? (pending?.kind === "verify-email" ? pending.email : "");
  const completeSignIn = useCompleteSignIn();

  const onVerified = async (body: unknown) => {
    await completeSignIn(body, { email, next: CONSOLE_PATHS.onboarding });
  };

  return (
    <AuthLayout title={t("auth.verify.title", { product: PRODUCT_NAME })} back={{ label: t("auth.common.back"), href: CONSOLE_PATHS.register }}>
      {email ? (
        <RegisterVerifyPane
          email={email}
          back={false}
          onChangeEmail={() => {
            void navigate(CONSOLE_PATHS.register);
          }}
          onVerified={onVerified}
        />
      ) : (
        <div className="r-pane">
          <h1 className="a-title">{t("auth.register.verifyTitle")}</h1>
          <FormAlert tone="info" title={t("auth.verify.missingEmail")} />
          <p className="a-foot">
            <AppLink href={CONSOLE_PATHS.register} className="a-link">
              {t("auth.register.changeEmail")}
            </AppLink>
          </p>
        </div>
      )}
    </AuthLayout>
  );
}
